class BnzImageTabs extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.bnz-image-tabs__tab-button');
    this.contents = this.querySelectorAll('.bnz-image-tabs__tab-content');
    this.tabImages = this.querySelectorAll('.bnz-image-tabs__tab-image');
    this.swipeArea = this.querySelector('.bnz-image-tabs__swipe-area') || this.querySelector('.bnz-image-tabs__content');
    this.swipeThreshold = 50;
    this.swipeStartX = 0;
    this.swipeStartY = 0;
    this.pointerId = null;
    this.init();
  }

  init() {
    if (this.buttons.length === 0 || this.contents.length === 0) return;

    this.buttons.forEach((button, index) => {
      button.addEventListener('click', (e) => this.handleTabClick(e, index));
      button.id = `tab-button-${button.dataset.tabId}`;
    });

    this.setActiveTab(0);

    if (this.swipeArea) {
      this.setupSwipe();
    }
  }

  getCurrentIndex() {
    const activeButton = this.querySelector('.bnz-image-tabs__tab-button.is-active');
    if (!activeButton) return 0;
    return Array.from(this.buttons).indexOf(activeButton);
  }

  setupSwipe() {
    const area = this.swipeArea;

    const handleStart = (clientX, clientY) => {
      this.swipeStartX = clientX;
      this.swipeStartY = clientY;
    };

    const handleEnd = (clientX, clientY) => {
      const deltaX = clientX - this.swipeStartX;
      const deltaY = clientY - this.swipeStartY;
      if (Math.abs(deltaX) <= this.swipeThreshold) return;
      if (Math.abs(deltaY) >= Math.abs(deltaX)) return;

      const current = this.getCurrentIndex();
      if (deltaX < 0) {
        this.setActiveTab(Math.min(current + 1, this.buttons.length - 1));
      } else {
        this.setActiveTab(Math.max(current - 1, 0));
      }
    };

    area.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return;
      handleStart(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });

    area.addEventListener('touchend', (e) => {
      if (e.changedTouches.length !== 1) return;
      handleEnd(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
    }, { passive: true });

    area.addEventListener('pointerdown', (e) => {
      if (this.pointerId !== null) return;
      this.pointerId = e.pointerId;
      handleStart(e.clientX, e.clientY);
    });

    area.addEventListener('pointermove', () => {});

    area.addEventListener('pointerup', (e) => {
      if (e.pointerId !== this.pointerId) return;
      handleEnd(e.clientX, e.clientY);
      this.pointerId = null;
    });

    area.addEventListener('pointercancel', (e) => {
      if (e.pointerId === this.pointerId) this.pointerId = null;
    });
  }

  handleTabClick(event, index) {
    event.preventDefault();
    this.setActiveTab(index);
  }

  setActiveTab(index) {
    const button = this.buttons[index];
    if (!button) return;

    const tabId = button.dataset.tabId;
    const content = this.querySelector(`.bnz-image-tabs__tab-content[data-tab-id="${tabId}"]`);

    if (!content) return;

    this.buttons.forEach((btn) => {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-selected', 'false');
    });

    this.contents.forEach((cnt) => {
      cnt.classList.remove('is-active');
    });

    this.tabImages.forEach((img) => {
      img.classList.toggle('is-active', img.dataset.tabId === tabId);
    });

    button.classList.add('is-active');
    button.setAttribute('aria-selected', 'true');
    content.classList.add('is-active');

    this.scrollToContent(content);
  }

  scrollToContent(content) {
    const rect = content.getBoundingClientRect();
    const offset = 100;

    if (rect.top < offset) {
      window.scrollTo({
        top: window.scrollY + rect.top - offset,
        behavior: 'smooth'
      });
    }
  }
}

customElements.define('bnz-image-tabs', BnzImageTabs);
